import {
  put,
  takeLatest,
  call,
} from 'redux-saga/effects';
import { 
  FETCH_EQUIPMENT_DATA,
  FETCH_CONSUMABLES_DATA,
  FETCH_QC_INSPECTION_PERSONNEL_DATA,
  REFRESH_EQUIPMENT_DATA,
  REFRESH_CONSUMABLES_DATA,
  REFRESH_QC_INSPECTION_PERSONNEL_DATA,
  FETCH_REGISTRY_MISCELLANEOUS_DATA,
  REFRESH_REGISTRY_MISCELLANEOUS_DATA,
} from './types';
import { 
  fetchEquipmentDataSuccess,
  fetchEquipmentDataFailure,
  fetchConsumablesDataSuccess,
  fetchConsumablesDataFailure,
  fetchInspectionPersonnelDataSuccess,
  fetchInspectionPersonnelDataFailure,
  fetchRegistryMiscellaneousDataSuccess,
  fetchRegistryMiscellaneousDataFailure,
} from './action';
import {
  getAllRegistries,
  getAllConsumables,
  getAllInspectionPersonnel,
  getAllRegistryMiscellaneous,
  normalizeRegistryMiscellaneousList,
} from '../registrySaga';

// Equipment Saga
function* fetchEquipmentDataSaga(action) {
  const { projectId } = action.payload;
  
  try {
    const response = yield call(getAllRegistries, { project_id: projectId });
    
    if (response) {
      yield put(fetchEquipmentDataSuccess({
        projectId,
        data: response
      }));
    } else {
      yield put(fetchEquipmentDataFailure('Failed to fetch equipment data'));
    }
  } catch (error) {
    yield put(fetchEquipmentDataFailure(error.message || 'Failed to fetch equipment data'));
  }
}

// Consumables Saga
function* fetchConsumablesDataSaga(action) {
  const { projectId } = action.payload;
  
  try {
    const response = yield call(getAllConsumables, { project_id: projectId });
    
    if (response) {
      yield put(fetchConsumablesDataSuccess({
        projectId,
        data: response
      }));
    } else {
      yield put(fetchConsumablesDataFailure('Failed to fetch consumables data'));
    }
  } catch (error) {
    yield put(fetchConsumablesDataFailure(error.message || 'Failed to fetch consumables data'));
  }
}

// QC Inspection Personnel Saga
function* fetchInspectionPersonnelDataSaga(action) {
  const { projectId } = action.payload;
  
  try {
    const response = yield call(getAllInspectionPersonnel, { project_id: projectId });
    
    if (response) {
      yield put(fetchInspectionPersonnelDataSuccess({
        projectId,
        data: response
      }));
    } else {
      yield put(fetchInspectionPersonnelDataFailure('Failed to fetch QC Inspection Personnel data'));
    }
  } catch (error) {
    yield put(fetchInspectionPersonnelDataFailure(error.message || 'Failed to fetch QC Inspection Personnel data'));
  }
}

// Refresh Sagas - Clear cache and refetch
function* refreshEquipmentDataSaga(action) {
  yield* fetchEquipmentDataSaga(action);
}

function* refreshConsumablesDataSaga(action) {
  yield* fetchConsumablesDataSaga(action);
}

function* refreshQCInspectionPersonnelDataSaga(action) {
  yield* fetchInspectionPersonnelDataSaga(action);
}

function* fetchRegistryMiscellaneousDataSaga(action) {
  const { projectId } = action.payload;
  try {
    const response = yield call(getAllRegistryMiscellaneous, { project_id: projectId });
    const list = normalizeRegistryMiscellaneousList(response);
    yield put(
      fetchRegistryMiscellaneousDataSuccess({
        projectId,
        data: list,
      })
    );
  } catch (error) {
    yield put(fetchRegistryMiscellaneousDataFailure(error.message || 'Failed to fetch data'));
  }
}

function* refreshRegistryMiscellaneousDataSaga(action) {
  yield* fetchRegistryMiscellaneousDataSaga(action);
}

export default function* registryDataSaga() {
  yield takeLatest(FETCH_EQUIPMENT_DATA, fetchEquipmentDataSaga);
  yield takeLatest(FETCH_CONSUMABLES_DATA, fetchConsumablesDataSaga);
  yield takeLatest(FETCH_QC_INSPECTION_PERSONNEL_DATA, fetchInspectionPersonnelDataSaga);
  yield takeLatest(FETCH_REGISTRY_MISCELLANEOUS_DATA, fetchRegistryMiscellaneousDataSaga);
  yield takeLatest(REFRESH_EQUIPMENT_DATA, refreshEquipmentDataSaga);
  yield takeLatest(REFRESH_CONSUMABLES_DATA, refreshConsumablesDataSaga);
  yield takeLatest(REFRESH_QC_INSPECTION_PERSONNEL_DATA, refreshQCInspectionPersonnelDataSaga);
  yield takeLatest(REFRESH_REGISTRY_MISCELLANEOUS_DATA, refreshRegistryMiscellaneousDataSaga);
}

